<template>
    <v-container fluid>
        <div class="container-form">
            <v-form
                ref="form"
                v-model="valid"
                lazy-validation
                class="auth-form w-100"
                @submit.prevent
            >
                <div class="container-form pa-0">
                    <v-layout row ma-0>
                        <v-flex class="d-inline-flex container-form__row">
                            <label for="name" class="main-text"> Название </label>
                            <v-text-field
                                v-model="controllerNewData.name"
                                placeholder="Название"
                                id="name"
                                class="input-form-grey"
                                :rules="[rules.required]"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row ma-0>
                        <v-flex class="container-form__row d-flex">
                            <div class="d-inline-flex btn-block justify-start">
                                <v-switch
                                    v-model="controllerNewData.enabled"
                                    inset
                                    dense
                                    class="pa-0 ma-0"
                                    color="#FF8484"
                                ></v-switch>
                                <div class="main-text ml-3">Включен</div>
                            </div>
                        </v-flex>
                    </v-layout>
                    <v-layout row ma-0>
                        <div v-for="(el, index) in controllerNewData.rules" :key="index" class="container-form__rule">
                            <v-flex class="d-inline-flex container-form__row flex-row justify-space-between">
                                <div class="d-inline-flex main-text">Правило {{index + 1}}</div>
                                <div class="close-btn" @click="deleteRule(index)">
                                    <v-img :src="require('@/assets/icons/close_icon.svg')" class="d-inline-flex"/>
                                </div>
                            </v-flex>
                            <v-flex class="d-inline-flex container-form__row">
                                <label for="dryContact" class="main-text"> Сухой контакт </label>
                                <v-select
                                    v-model="el.input"
                                    placeholder="Сухой контакт"
                                    id="dryContact"
                                    class="input-form-grey"
                                    :items="dryContacts"
                                    item-text="title"
                                    item-value="value"
                                    :menu-props="{
                                        bottom: true,
                                        offsetY: true,
                                        closeOnContentClick: true,
                                    }"
                                    :rules="[rules.required]"
                                >
                                    <template #item="{item}">
                                        <v-flex style="padding: 10px 22px">{{item.title}}</v-flex>
                                    </template>
                                    <template #selection="{item}">
                                        <v-flex>{{item.title}}</v-flex>
                                    </template>
                                    <template #no-data>
                                        <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-flex class="d-inline-flex container-form__row">
                                <label for="ruleType" class="main-text"> Тип правила </label>
                                <v-select
                                    v-model="el.rule_type"
                                    placeholder="Тип правила"
                                    id="ruleType"
                                    class="input-form-grey"
                                    :items="ruleTypes"
                                    item-text="title"
                                    item-value="value"
                                    :menu-props="{
                                        bottom: true,
                                        offsetY: true,
                                        closeOnContentClick: true,
                                    }"
                                    :rules="[rules.required]"
                                >
                                    <template #item="{item}">
                                        <v-flex style="padding: 10px 22px">{{item.title}}</v-flex>
                                    </template>
                                    <template #selection="{item}">
                                        <v-flex>{{item.title}}</v-flex>
                                    </template>
                                    <template #no-data>
                                        <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                    </template>
                                </v-select>
                            </v-flex>
                            <v-flex class="d-inline-flex container-form__row">
                                <label for="relatedRelays" class="main-text"> Связанные реле </label>
                                <v-select
                                    v-model="el.relays"
                                    placeholder="Связанные реле"
                                    id="relatedRelays"
                                    class="input-form-grey"
                                    :items="relatedRelays"
                                    item-text="title"
                                    item-value="value"
                                    :menu-props="{
                                        bottom: true,
                                        offsetY: true,
                                        closeOnContentClick: true,
                                    }"
                                    multiple
                                >
                                    <template v-slot:item="{item, tile}">
                                        <v-flex style="padding: 10px 22px">
                                            <v-checkbox :input-value="tile.props.value"/>
                                            <div>{{ item.title }}</div>
                                        </v-flex>
                                    </template>
                                    <template #item="{item}">
                                        <v-flex style="padding: 10px 22px">{{item.title}}</v-flex>
                                    </template>
                                    <template #selection="{item}">
                                        <v-flex class="d-inline-flex pr-1" style="max-width: fit-content">
                                            {{item.title}}
                                            <span v-if="item.title != el.relays[el.relays.length - 1]">,</span>
                                        </v-flex>
                                    </template>
                                    <template #no-data>
                                        <v-flex style="padding: 10px 22px">Нет доступных элементов</v-flex>
                                    </template>
                                </v-select>
                            </v-flex>
                        </div>
                    </v-layout>
                    <v-flex xs12 px-10 mt-3>
                        <v-btn class="btn-light-grey main-text" @click="addRule">
                            Добавить правило
                        </v-btn>
                    </v-flex>
                    <v-layout class="w-100 my-4 justify-end" row>
                        <v-btn class="btn-grey main-text mr-3" @click="back">
                            Отмена
                        </v-btn>
                        <v-btn
                            class="btn-grey common-text ma-0"
                            :disabled="!valid"
                            type="submit"
                            @click="validate"
                        >
                            Сохранить
                        </v-btn>
                    </v-layout>
                </div>
            </v-form>
        </div>
        <ModalWaiting ref="modalWaiting" title="Загрузка данных"></ModalWaiting>
    </v-container>
</template>

<script>
import ModalWaiting from "@/components/modals/ModalWaiting";

export default {
    name: "DebugControllerForm",
    components: {ModalWaiting},
    props: {
        controllerId: {
            type: String,
            required: true,
        },
        controllerFullData: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            controllerData: {},
            controllerNewData: {
                rules: [],
            },
            newRule: {
                input: null,
                rule_type: null,
                relays: [],
            },
            dryContacts: [],
            ruleTypes: [],
            relatedRelays: [],
            rules: {
                required: v => !!v || !!v && v.length > 0 || "Обязательное поле",
            },
            valid: true,
        };
    },
    mounted() {
        this.getController();
    },
    methods: {
        getController() {
            this.controllerData = JSON.parse(JSON.stringify(this.controllerFullData));
            if (this.controllerData) {
                this.controllerNewData.name = this.controllerData.name;
                this.controllerNewData.enabled = this.controllerData.enabled;
                this.controllerNewData.rules = this.controllerData.settings.rules;
                this.dryContacts = this.controllerData.available_settings.input;
                this.ruleTypes = this.controllerData.available_settings.rule_type;
                this.relatedRelays = this.controllerData.available_settings.relays;
                this.addRule();
            }
        },
        back() {
            if (this.controllerData && this.controllerData.hotel_room) {
                this.$router.push({name: "roompage", params: {id: this.controllerData.hotel_room.uid}});
            }
        },
        addRule() {
            this.controllerNewData.rules.push(JSON.parse(JSON.stringify(this.newRule)));
        },
        deleteRule(index) {
            this.controllerNewData.rules.splice(index, 1);
        },
        validate() {
            this.valid = this.$refs.form.validate();
            if (this.valid) {
                this.addController();
            }
        },
        addController() {
            this.controllerNewData.name = this.controllerData.name;
            this.controllerNewData.enabled = this.controllerData.enabled;
            this.controllerNewData.rules = this.controllerData.settings.rules;
            let data = {
                name: this.controllerNewData.name,
                enabled: this.controllerNewData.enabled,
                settings: {
                    thermostats: [],
                    rules: this.controllerNewData.rules,
                },
            };
            this.$http.patch('/controllers/hotel-admin/controller/' + this.controllerId + '/', data)
                .then(() => {
                    this.back();
                })
                .catch((error) => {
                    console.log(error);
                    this.dialog = true;
                });
        }
    },
}
</script>

<style lang="scss" scoped>
.main-container {
    height: 100%;
    text-align: center;

    .container-form {
        width: 100%;
        display: inline-flex;
        justify-content: center;
        flex-direction: column;
        text-align: left;
        padding: 0 40px;

        &__row {
            width: 100%;
            display: inline-flex;
            flex-direction: column;
            justify-content: flex-start;
            align-items: flex-start;
            gap: 2px;
            margin-bottom: 6px;

            > label {
                margin-left: 20px;
            }
        }

        &__rule {
            border: 1px solid #787878;
            border-radius: 12px;
            padding: 8px 12px;
            margin: 4px 0;
            width: 100%;
        }
    }
}

.controller-name {
    display: flex;
    justify-content: center;
    align-items: flex-end;
    font-weight: 500;
    font-size: 26px;
    line-height: 32px;
    color: #130F26;
    margin-bottom: 20px;
}

.btn-grey.v-btn {
    display: inline-flex;
    width: auto;
    padding: 10px 16px;
    text-transform: none;
    margin-right: 10px;
}

.btn-light-grey {
    min-height: 60px;
    height: 60px;
}

.v-input.input-form-grey {
    width: 100%;
    max-width: 100%;
    position: relative;

    &::v-deep .v-input__control {
        display: flex;
        width: 100%;

        .v-input__slot {
            margin-bottom: 0;
            top: 14px;

            .v-text-field__slot,
            .v-select__slot .v-select__selections > div {
                max-height: 28px;
                width: 200px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }
        }

        .v-text-field__details {
            top: 12px;
            position: relative;
        }
    }
}

.connection-animate {
    animation: scale 1s infinite linear;
}
@keyframes scale {
    0% {
        transform: scaleX(-1);
    }
    50% {
        transform: scaleX(-1);
    }
    51% {
        transform: scaleX(1);
    }
    100% {
        transform: scaleX(1);
    }
}
</style>